import AES from "crypto-js/aes"
import Utf8 from "crypto-js/enc-utf8";
import global from "@/global";

const encrypt = value => {
    const key = global.getAppSettings().cryptoKey;
    let valueStr;

    if (typeof value !== "string") {
        valueStr = JSON.stringify(value);
    } else {
        valueStr = value;
    }

    const encrypted = AES.encrypt(valueStr, key);
    return encrypted.toString();
}

const decrypt = value => {
    const key = global.getAppSettings().cryptoKey;
    const decrypted = AES.decrypt(value, key);
    const decryptedStr = decrypted.toString(Utf8);

    if (decryptedStr) {
        try {
            return JSON.parse(decryptedStr);
        }
        catch
        {
            return decryptedStr
        }
    }

    return null;
}

export default {
    encrypt,
    decrypt
}